import { CommonUI } from "@src/common/CommonUI/CommonUI";
import { IllustrationBG } from "@src/common/IllustrationBG/IllustrationBG";
import { PageLayout } from "@src/common/PageLayout";
import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useResolvedPageLabels } from "@src/hooks/useResolvedPageLabels";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";
import { styled } from "@uhg-abyss/web/tools/styled";
import { PatientScreenerForm } from "./PatientScreenerForm";

const PatientScreenerContent = styled("div", {
  height: "auto !important",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "start",
  width: "100%",
});

export const PatientScreener = () => {
  const isMobile = useMediaQuery(MEDIA_QUERIES.mobileMax);
  const labels = useResolvedPageLabels("patientScreener");

  return (
    <PageLayout css={{ paddingBottom: isMobile ? "0" : "50px" }}>
      <IllustrationBG iconName="clinical_exam_1" ariaLabel="Clinical exam illustration" />
      <PatientScreenerContent data-testid="test-id-patient-screener-content">
        <CommonUI
          headingText={labels.headingText}
          metaTitle={labels.headingText}
          bodyText={labels.bodyText}
          FormComponent={PatientScreenerForm}
        />
      </PatientScreenerContent>
    </PageLayout>
  );
};
